var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagPrice = function SvgTagPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.058 22.277-5.334-5.333 1.886-1.886 5.333 5.333zM13.724 12.944l5.334 5.333 1.885-1.886-5.333-5.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m26.553 7.334 3.723-3.724-1.885-1.885-3.724 3.723-1.057-1.057c-.25-.25-.59-.39-.943-.39H16c-.353 0-.693.14-.943.39l-12 12c-.52.521-.52 1.365 0 1.886l10.667 10.667c.52.52 1.365.52 1.886 0l12-12c.25-.25.39-.59.39-.943V9.334c0-.354-.14-.693-.39-.943zm-3.772 0-.666-.667h-5.562L5.886 17.334l8.78 8.781L25.335 15.45V9.886l-.667-.666-.67.67Q24 9.943 24 10a2 2 0 1 1-1.888-1.996z",
    clipRule: "evenodd"
  })));
};
export default SvgTagPrice;